import { startCase } from "lodash";
import { Badge } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface Props {
    label: string;
    value: string | React.ReactNode;
    status?: string;
    "data-attr-id"?: string;
}

export default function SubscriptionInfo({
    label,
    value,
    status,
    "data-attr-id": dataAttrId,
}: Props) {
    const { t } = useTranslation();
    return (
        <div
            className="d-flex justify-content-between sub-info gap-2"
            data-attr-id={dataAttrId}
        >
            <div
                className="d-flex justify-content-between sub-info-label"
                style={{ flex: 1, flexGrow: 1 }}
            >
                <p
                    className="label mb-0"
                    style={{ flex: 1, fontWeight: "500" }}
                >
                    {label}
                </p>
                <p className="text-center mb-0">:</p>
            </div>
            <div
                style={{
                    flex: 1,
                    flexGrow: 1,
                    display: "flex",
                    justifyContent: "flex-end",
                }}
            >
                {status ? (
                    <div className="sub-info-value">
                        <Badge
                            className={`subscription-badge subscription-badge--${status}`}
                        >
                            {startCase(t(status))}
                        </Badge>
                    </div>
                ) : (
                    <p
                        className="sub-info-value mb-0"
                        style={{ flex: 1, textAlign: "right" }}
                    >
                        {value}
                    </p>
                )}
            </div>
        </div>
    );
}
